import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "timi-workspace-container timi-workspace-container-admin" }
const _hoisted_2 = {
  key: 0,
  class: "system-info"
}
const _hoisted_3 = {
  key: 1,
  class: "timi-workspace-content timi-workspace-content-admin workspace-scan-admin-chip"
}
const _hoisted_4 = { class: "workspace-admin-message" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "workspace-admin-chip" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "timi-workspace-column timi-workspace-column-action" }
const _hoisted_9 = {
  key: 2,
  class: "timi-workspace-content timi-workspace-content-admin"
}
const _hoisted_10 = { class: "timi-workspace-column timi-workspace-column-action" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "row justify-content-center" }
const _hoisted_13 = { class: "row has-padding-small gap-small" }
const _hoisted_14 = { class: "display-property col-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "property-label" }, "Aktuelle Workstation ID", -1)
const _hoisted_16 = { class: "property-value" }
const _hoisted_17 = { class: "display-property col-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "property-label" }, "Host", -1)
const _hoisted_19 = { class: "property-value" }
const _hoisted_20 = { class: "display-property col-6" }
const _hoisted_21 = { class: "property-label" }
const _hoisted_22 = { class: "property-value" }
const _hoisted_23 = { class: "display-property col-6" }
const _hoisted_24 = { class: "property-label" }
const _hoisted_25 = { class: "property-value" }
const _hoisted_26 = { class: "display-property col-6" }
const _hoisted_27 = { class: "property-label" }
const _hoisted_28 = { class: "property-value" }
const _hoisted_29 = { class: "display-property col-6" }
const _hoisted_30 = { class: "property-label" }
const _hoisted_31 = { class: "property-value" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 0,
  class: "timi-workspace-column timi-workspace-content-admin"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 1,
  class: "timi-detail-column timi-workspace-content-admin"
}
const _hoisted_36 = { class: "timi-form-item" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = { class: "form-footer justify-flexend" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 0,
  class: "timi-workspace-column timi-workspace-content-admin"
}
const _hoisted_41 = { class: "row has-padding-small gap-small justify-flexend" }
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = { class: "col-12" }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = {
  key: 0,
  class: "timi-workspace-column timi-workspace-content-admin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Timeout: " + _toDisplayString(this.closeTimeout) + " Last set: " + _toDisplayString(_ctx.timeoutLastSet.getHours() + ':' + _ctx.timeoutLastSet.getMinutes() + ':' + _ctx.timeoutLastSet.getSeconds()), 1))
      : _createCommentVNode("", true),
    (!_ctx.adminEmployee)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Card, null, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$t('label.scanAdminChip')), 1),
                _hoisted_5,
                _createTextVNode(_toDisplayString(_ctx.noAdminChipId), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('label.enterAdminChipManually')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: _ctx.$t('placeholder.adminChipId'),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.adminChipId) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAdminChipIdChange && _ctx.onAdminChipIdChange(...args)))
                }, null, 40, _hoisted_7), [
                  [_vModelText, _ctx.form.adminChipId]
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_IconButton, {
              label: _ctx.$t('button.back'),
              primary: true,
              icon: _ctx.store.getters.svgIcons.arrowbackward,
              onClick: _ctx.onBack
            }, null, 8, ["label", "icon", "onClick"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_IconButton, {
              label: _ctx.$t('button.back'),
              icon: _ctx.store.getters.svgIcons.arrowbackward,
              onClick: _ctx.onBack
            }, null, 8, ["label", "icon", "onClick"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (!(_ctx.setupWorkstation || _ctx.setupChip || _ctx.resetWorkstation))
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 0,
                  class: "transparent"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Button, {
                        primary: true,
                        raised: true,
                        text: _ctx.$t('button.setupWorkstation'),
                        onClick: _cache[2] || (_cache[2] = () => _ctx.setupWorkstation = true)
                      }, null, 8, ["text"]),
                      _createVNode(_component_Button, {
                        primary: true,
                        raised: true,
                        text: _ctx.$t('button.setupChip'),
                        onClick: _cache[3] || (_cache[3] = () => _ctx.setupChip = true)
                      }, null, 8, ["text"]),
                      _createVNode(_component_Button, {
                        primary: true,
                        raised: true,
                        text: _ctx.$t('button.resetWorkstation'),
                        onClick: _cache[4] || (_cache[4] = () => _ctx.resetWorkstation = true)
                      }, null, 8, ["text"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!(_ctx.setupWorkstation || _ctx.setupChip || _ctx.resetWorkstation))
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 1,
                  title: "Aktuelle Einstellungen"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.localStorageWorkstationUuid), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.currentHost), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('workstation.nfcChipReader')), 1),
                        _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.workstation?.nfcChipReader), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('workstation.presenceAllowed')), 1),
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.workstation?.presenceAllowed), 1)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('workstation.workbreakAllowed')), 1),
                        _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.workstation?.workbreakAllowed), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('workstation.timeentryAllowed')), 1),
                        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.workstation?.timeentryAllowed), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.setupChip)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                (!_ctx.employee.uid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createVNode(_component_Card, null, {
                        default: _withCtx(() => [
                          (_ctx.employees.length)
                            ? (_openBlock(), _createBlock(_component_Table, {
                                key: 0,
                                tableData: _ctx.employeeTableData,
                                src: _ctx.filteredEmployees,
                                emptyStateText: _ctx.$t('emptyState.employees'),
                                onOnActionClicked: _ctx.onTableActionClicked,
                                class: "header-small"
                              }, null, 8, ["tableData", "src", "emptyStateText", "onOnActionClicked"]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_34, "No data"))
                        ]),
                        _: 1
                      })
                    ]))
                  : (_ctx.setupChip)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createVNode(_component_Card, { class: "transparent border" }, {
                          default: _withCtx(() => [
                            _createElementVNode("form", {
                              onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitPrevent && _ctx.onSubmitPrevent(...args)), ["prevent"]))
                            }, [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.$t('label.nfcChipId')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  placeholder: _ctx.$t('placeholder.nfcChipId'),
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.nfcChipId ) = $event))
                                }, null, 8, _hoisted_37), [
                                  [_vModelText, _ctx.form.nfcChipId ]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_38, [
                                _createVNode(_component_Button, {
                                  text: _ctx.$t('button.cancel'),
                                  onOnClick: _ctx.onCancel
                                }, null, 8, ["text", "onOnClick"]),
                                _createVNode(_component_Button, {
                                  text: _ctx.$t('button.save'),
                                  primary: true,
                                  raised: true,
                                  onOnClick: _ctx.onSave
                                }, null, 8, ["text", "onOnClick"])
                              ])
                            ], 32)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.setupWorkstation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                (!_ctx.employee.uid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createVNode(_component_Card, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("p", null, "Aktuelle Workstation ID: " + _toDisplayString(_ctx.localStorageWorkstationUuid), 1)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("p", null, "Host: " + _toDisplayString(_ctx.currentHost), 1)
                            ])
                          ]),
                          (_ctx.workstations.length)
                            ? (_openBlock(), _createBlock(_component_Table, {
                                key: 0,
                                tableData: _ctx.workstationTableData,
                                src: _ctx.filteredWorkstations,
                                emptyStateText: _ctx.$t('emptyState.workstations'),
                                onOnActionClicked: _ctx.onTableActionClicked,
                                class: "header-small"
                              }, null, 8, ["tableData", "src", "emptyStateText", "onOnActionClicked"]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_44, "No data"))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.resetWorkstation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                (!_ctx.employee.uid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createVNode(_component_Card, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('label.resetWorkstation')), 1),
                          _createVNode(_component_Button, {
                            text: _ctx.$t('button.ok'),
                            primary: true,
                            raised: true,
                            onOnClick: _ctx.onResetWorkstation
                          }, null, 8, ["text", "onOnClick"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}